import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { shortenAddress } from '@libs/hooks';
import Radio from '../radio/Radio';
import { ModalContent, Separator } from './styles';
const AddressOptionsContent = ({ options, selectedOptionId, onOptionSelection, closeModal, }) => {
    return (_jsx(ModalContent, { children: options?.map((opt, index) => {
            const isLast = index === options.length - 1;
            const isSelected = selectedOptionId === opt.id;
            const handleSelection = () => {
                onOptionSelection?.(opt.id);
                closeModal?.();
            };
            return (_jsxs(Fragment, { children: [_jsx(Radio, { icon: opt.icon, title: shortenAddress(opt.title), disabled: false, checked: isSelected, onClick: handleSelection, description: opt.description }), !isLast && _jsx(Separator, {})] }, opt.id));
        }) }));
};
export default AddressOptionsContent;
//# sourceMappingURL=AddressOptionsContent.js.map